import React, { ReactElement } from "react";
import InputText from "./InputText";
import type { InputTextProps } from "./InputText";
import type { Ref } from "react";

type PasswordTextProps = Omit<
  InputTextProps,
  "secureTextEntry" | "keyboardType" | "autoCompleteType" | "textContentType"
> & {
  inputRef?: Ref<any>;
};

const PasswordText = ({
  inputRef,
  ...props
}: PasswordTextProps): ReactElement => {
  return (
    <InputText
      secureTextEntry
      keyboardType="default"
      autoComplete="password"
      textContentType="password"
      {...props}
      inputRef={inputRef}
      testID="passwordInput"
    />
  );
};

export default PasswordText;
